<h5>Chairman Extension</h5>

<ng-container *ngFor="let item of chairmanExtensionKeysLookup">
  <ng-container *var="item.value | changeLogChildKey as key">
    <ng-container *ngIf="changeLogs[key] as log">
      <ng-container [ngSwitch]="key">
        <div class="pl-4 ps-4" *ngSwitchCase="RegistrantChairmanExtensionKeys.guestConfiguration">
          <ag-shr-change-log-guest-configuration [log]="log"></ag-shr-change-log-guest-configuration>
        </div>

        <div class="pl-4 ps-4" *ngSwitchCase="RegistrantChairmanExtensionKeys.selectedExcursions">
          <ag-shr-excursions-change-log
            [changeLogs]="getChangedLog(log)"
            [attendeeName]="attendeeName"
            [isChairmanExt]="true"
            [conference]="changesHistoryGridService.conferenceSig()"
          ></ag-shr-excursions-change-log>
        </div>

        <div class="pl-4 ps-4" *ngSwitchDefault>
          <ag-shr-change-log-detail-by-type
            [keysConfig]="[item]"
            [changeLogs]="changeLogs"
          ></ag-shr-change-log-detail-by-type>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
